<template>
	<v-menu
		v-model="innerMenu"
		:offset-y="true"
		:close-on-content-click="false"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="activatorText"
				:class="[activatorClass, { 'filter-menu-activator--compact': compactActivator }]"
				:block="activatorBlock"
				:style="activatorStyle"
				:loading="activatorLoading"
				:disabled="activatorDisabled"
				v-bind="attrs"
				v-on="on"
				@click="onActivatorClick"
			>
				<p v-if="showLabel" class="mb-0 font-weight-bold body-2 text-capitalize">{{ label }}</p>
				<v-icon :color="activatorIconColor" small :class="showLabel ? 'ml-1':''">{{ activatorIcon }}</v-icon>
			</v-btn>
		</template>

		<v-list dense class="filter-selector-list">
			<v-list-item dense style="min-height: auto;">
				<div style="width: 100%" class="mb-2">
					<p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">{{ listTitle }}</p>
					<v-divider></v-divider>
				</div>
			</v-list-item>

			<v-list-item dense style="min-height: auto;" v-if="searchEnabled">
				<v-text-field
					class="mb-3"
					v-model="search"
					dense
					hide-details
					clearable
					:placeholder="searchPlaceholder"
					prepend-inner-icon="mdi-magnify"
				/>
			</v-list-item>

			<v-list-item-group
				:multiple="multiple"
				:value="groupValue"
				@change="onChange"
				:style="listStyle"
			>
				<v-list-item
					style="min-height: auto;"
					v-for="(item, index) in filteredItems"
					:key="getKey(item, index)"
					:value="getValue(item)"
				>
					<template v-slot:default="{ active }">
						<v-list-item-title class="my-0 d-flex flex-row align-center">
							<v-checkbox
								v-if="showCheckbox"
								dense
								hide-details
								class="caption my-0 py-0"
								:input-value="active"
							></v-checkbox>
							<v-icon v-else color="#5e85ef" small class="mr-2">{{active ? 'mdi-radiobox-marked':'mdi-radiobox-blank'}}</v-icon>
							<p class="mb-0 caption">{{ getText(item) }}</p>
						</v-list-item-title>
					</template>
				</v-list-item>
			</v-list-item-group>

			<v-list-item dense style="min-height: auto;">
				<v-btn x-small block color="#5e85ef" dark class="mt-2" @click="apply">
					<v-icon color="white" small class="mr-1">mdi-filter-outline</v-icon>
					<p class="mb-0 caption text-capitalize">Aplicar</p>
				</v-btn>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	name: 'FilterMenu',
	props: {
		value: {
			type: Array,
			default: () => []
		},
		items: {
			type: Array,
			default: () => []
		},
		label: {
			type: String,
			default: 'Filtro'
		},
		itemValue: {
			type: [String, Function],
			default: 'id'
		},
		itemText: {
			type: [String, Function],
			default: 'name'
		},
		searchEnabled: {
			type: Boolean,
			default: false
		},
		searchPlaceholder: {
			type: String,
			default: 'Buscar...'
		},
		maxHeight: {
			type: [Number, String],
			default: null
		},
		closeOnApply: {
			type: Boolean,
			default: true
		},
		multiple: {
			type: Boolean,
			default: true
		},
		showCheckbox: {
			type: Boolean,
			default: true
		},
		showLabel: {
			type: Boolean,
			default: true
		},
		listTitle: {
			type: String,
			default: 'Filtrar Por:'
		},
		activatorIcon: {
			type: String,
			default: 'mdi-plus-circle'
		},
		activatorIconColor: {
			type: String,
			default: '#5e85ef'
		},
		activatorText: {
			type: Boolean,
			default: true
		},
		activatorBlock: {
			type: Boolean,
			default: true
		},
		activatorClass: {
			type: [String, Array, Object],
			default: 'table-header-button d-flex flex-row pa-0 justify-start'
		},
		activatorStyle: {
			type: [String, Object, Array],
			default: 'height: auto;'
		},
		activatorLoading: {
			type: Boolean,
			default: false
		},
		activatorDisabled: {
			type: Boolean,
			default: false
		},
		compactActivator: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		innerMenu: false,
		search: ''
	}),
	computed: {
		filteredItems() {
			const list = this.items || []
			if (!this.searchEnabled) return list
			const q = (this.search || '').trim().toLowerCase()
			if (!q) return list
			return list.filter(i => String(this.getText(i) || '').toLowerCase().includes(q))
		},
		listStyle() {
			if (!this.maxHeight) return ''
			return `max-height: ${this.maxHeight}px; overflow-y: auto;`
		},
		groupValue() {
			if (this.multiple) return this.value
			return Array.isArray(this.value) && this.value.length > 0 ? this.value[0] : null
		}
	},
	methods: {
		onChange(val) {
			const nextValue = this.multiple
				? (Array.isArray(val) ? val : [])
				: (val != null ? [val] : [])
			this.$emit('input', nextValue)
			this.$emit('update:value', nextValue)
		},
		apply() {
			this.$emit('apply')
			if (this.closeOnApply) this.innerMenu = false
		},
		onActivatorClick(event) {
			this.$emit('activator-click', event)
		},
		getValue(item) {
			return typeof this.itemValue === 'function' ? this.itemValue(item) : item?.[this.itemValue]
		},
		getText(item) {
			return typeof this.itemText === 'function' ? this.itemText(item) : item?.[this.itemText]
		},
		getKey(item, index) {
			const v = this.getValue(item)
			return v != null ? v : index
		},
		close() {
			this.innerMenu = false
		}
	}
}
</script>

<style scoped>
	.text-primary-color{
		color: #2D4B95;
	}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}
	.filter-menu-activator--compact.v-btn {
		box-shadow: none;
		font-size: 13px;
		height: 32px;
		min-width: 0!important;
		max-width: 100%;
		padding: 0 8px;
		text-transform: none;
		white-space: nowrap;
	}
</style>
